;(function (EmailPushdown, $) {

  var $dom = {};

  var cacheDom = function () {
    $dom.body = $('body');
    $dom.emailPushdown = $('[data-email-pushdown]');
    $dom.closeEmailPushdown = $('[data-close-email-pushdown]');
    $dom.toggleEmailPushdown = $('[data-toggle-email-pushdown]');
    $dom.toggleEmailParent = $dom.toggleEmailPushdown.parent();
    $dom.nonPushdownFixedElements = getNonPushdownFixedElements();
    $dom.mobileMenu = $('.js-mobile-menu');
  };

  var addTransitionStyles = function () {
    $dom.body.css('transition', 'all 200ms ease-in-out');
    $dom.nonPushdownFixedElements.css('transition', 'all 200ms ease-in-out');
  };

  var getNonPushdownFixedElements = function () {
    return $('.js-countdown-banner, .email-pushdown-toggle-container').filter(function () {
      return $(this).css('position') == 'fixed';
    }).filter(function () {
      return $(this).is(':visible') && !$(this)[0].hasAttribute('data-email-pushdown') && !$(this)[0].hasAttribute('data-inline-cart');
    });
  };

  var getEmailPushdownHeight = function () {
    return $dom.emailPushdown.height();
  };

  var getBodyHeightFromTop = function () {
    return $dom.body.offset().top + parseInt($dom.body.css('padding-top').slice(0, -2), 10);
  };

  var countdownBarFinishedLoading = function () {
    return (parseInt($dom.body.css('padding-top').slice(0, -2), 10) == $("#epb_bar").outerHeight(!0));
  };

  const setMobileTop = () => {
    let windowHeight = $(window).innerHeight();
    let mobileNav = $('.nav-header__mobile-menu');
    let bannerHeight = $('.banner-is-shown').innerHeight();
    let emailPushdown = $('.email-pushdown.is-active').innerHeight();
    let navHeaderHeight = $('.main-header-wrapper').innerHeight();
    let heightFromTop = bannerHeight + emailPushdown + navHeaderHeight;
    let navHeight = windowHeight - heightFromTop;

    mobileNav.css('height', navHeight)
    $dom.mobileMenu.animate({top:heightFromTop},200)
  }

  var checkForCountdownBanner = function () {
    if ($('.js-countdown-banner').length > 0) {
      $('.mobile-transformation-link-header').css('padding-top', $('.js-countdown-banner').outerHeight() + 'px');
    }
  };

  var bindUIActions = function () {

    $dom.closeEmailPushdown.on('click', function() {
      EmailPushdown.hide();
      if ($dom.toggleEmailPushdown.hasClass('is-open')) {
        $dom.toggleEmailPushdown.removeClass('is-open');
      }
      setMobileTop();
    });

    $dom.toggleEmailPushdown.on('click', function() {
      if ($dom.emailPushdown.hasClass('is-active')) {
        EmailPushdown.hide();
        $dom.toggleEmailPushdown.removeClass('is-open');
      }
      else {
        EmailPushdown.show();
        $dom.toggleEmailPushdown.addClass('is-open');
      }
      setMobileTop();
    });

    $(window).on('resize orientationchange', () => {
      checkForCountdownBanner();
    });

  };

  var repositionBars = function (attempts) {
    if( ($( "#epb_bar" ).length && countdownBarFinishedLoading() ) || attempts==5){
      EmailPushdown.show();
    } else {
      var total = attempts + 1;
      setTimeout(function(){ repositionBars(total) }, 1000);
    }
  };

  EmailPushdown.show = function () {
    $dom.nonPushdownFixedElements.css('padding-top', getEmailPushdownHeight() + 'px');
    $dom.body.css('padding-top', getBodyHeightFromTop() + getEmailPushdownHeight() + 'px');
    $dom.body.addClass('email-pushdown-is-active');
    $dom.emailPushdown.addClass('is-active');
    $('#epb_background').css('transform', 'translateY(' + getEmailPushdownHeight() + 'px' + ')');
  };

  EmailPushdown.hide = function () {
    $dom.nonPushdownFixedElements.css('padding-top', '0px');
    $dom.body.css('padding-top', getBodyHeightFromTop() - getEmailPushdownHeight() + 'px');
    $dom.body.removeClass('email-pushdown-is-active');
    $dom.emailPushdown.removeClass('is-active');
    $('#epb_background').css('transform', 'translateY(0)');
    //$dom.emailPushdown.remove();
    EmailPushdown.setCookie('newsletterBar', 'hidden');
  };

  EmailPushdown.setCookie = function (key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
  };

  EmailPushdown.getCookie = function (key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  };

  EmailPushdown.init = function () {
    cacheDom();
    checkForCountdownBanner();
    addTransitionStyles();
    bindUIActions();

    if(!EmailPushdown.getCookie('newsletterBar') || EmailPushdown.getCookie('newsletterBar') != 'hidden'){
      if(window.attachEvent) {
        window.attachEvent('onload', repositionBars(1));
      } else {
        window.addEventListener('load', repositionBars(1), false);
      }
    }
  };

}(window.EmailPushdown = window.EmailPushdown || {}, jQuery));
